var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategories = function SvgCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.168 7.25a1 1 0 0 1 1-1h6.667a1 1 0 0 1 1 1v6.667a1 1 0 0 1-1 1H7.168a1 1 0 0 1-1-1V7.25Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.502 10.249h-.667a1.333 1.333 0 0 1-1.333-1.334v-6c0-.736.597-1.333 1.333-1.333h6c.737 0 1.334.597 1.334 1.333v.667",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgCategories as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.16797 7.25C6.16797 6.69772 6.61568 6.25 7.16797 6.25H13.8346C14.3869 6.25 14.8346 6.69772 14.8346 7.25V13.9167C14.8346 14.469 14.3869 14.9167 13.8346 14.9167H7.16797C6.61568 14.9167 6.16797 14.469 6.16797 13.9167V7.25Z' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M3.50195 10.2487H2.83529C2.09891 10.2487 1.50195 9.65174 1.50195 8.91536V2.91536C1.50195 2.17898 2.09891 1.58203 2.83529 1.58203H8.83529C9.57167 1.58203 10.1686 2.17898 10.1686 2.91536V3.58203' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";